(function($) {

	//
	$(document).ready(function() {

		//
		var $body = $('body');

		//
		var openHamburgerMenu = function() {
			var adminBarHeight = $('#wpadminbar').height() + 0;

			console.log(adminBarHeight);

			// Set body's top css attribute to current scroll top position, and open navigation.
			$body.css('top', (-$(window).scrollTop() + adminBarHeight) + 'px').addClass('hamburger-open');
		};

		//
		var closeHamburgerMenu = function() {

			var adminBarHeight = $('#wpadminbar').height() + 0;

			// Get body's top css attrubute.
			var top = Math.abs(parseInt($('body').css('top')));

			// Set body's top css attribute to current scroll top position, and open navigation.
			$body.css('top', 0).removeClass('hamburger-open');

			// Set scroll position to bod's old top value.
			$(window).scrollTop(top + adminBarHeight);

			window.setTimeout(function() {
				var $headerElement = $('header');
				var scrollPosition = $(this).scrollTop();
				var pageWidth = $(this).width();

				if(pageWidth > 600) {
					$headerElement.css({top: adminBarHeight});
				} else {
					if(scrollPosition > adminBarHeight) {
						$headerElement.css({top: 0});
					} else {
						$headerElement.css({top: adminBarHeight - scrollPosition});
					}
				}
			}, 10);
		};

		//
		$body.on('click', '[data-toggle-nav]', function(event) {

			//
			event.stopPropagation();

			//
			openHamburgerMenu();
		});

		//
		$('#close-menu').on('click', function() {
			//
			closeHamburgerMenu();
		});


		$body.on('click', '#hamburger-menu', function() {
			//
			closeHamburgerMenu();
		});

		$body.on('click', '#hamburger-menu .menu-content', function(event) {
			//
			event.stopPropagation();
		});

		//
		$('#hamburger-menu').on('click', 'a', function(event) {

			//
			var $parentLi = $(this).parent('li');

			//
			if($(this).attr('href') === "#") {

				//
				event.preventDefault();

				//
				if($parentLi.hasClass('open')) {

					//
					$parentLi.find('> ul').slideUp(200, function() {

						//
						$parentLi.removeClass('open');
					});

				} else {

					//
					$parentLi.find('> ul').slideDown(200, function() {

						//
						$parentLi.addClass('open');
					});
				}
			}
		});
	});

})(window.jQuery);
